import { OrganizationContact } from "@models/organizationContact.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const ContactDetailsActions = createActionGroup({
  source: "ContactDetails",
  events: {
    "Contact Details Component Loaded": emptyProps(),
    "Open Add Contact Pressed": emptyProps(),
    "Open Edit Contact Pressed": props<{ contact: OrganizationContact }>(),
    "Open Delete Contact Pressed": props<{ name: string; id: string }>(),

    "Search Input Changed": props<{ search: string }>(),
    "Items Per Page Changed": props<{ items: number }>(),
    "Page Number Changed": props<{ page: number }>(),

    "Get Contact Details Success": props<{
      details: OrganizationContact[];
      totalItems: number;
    }>(),
    "Get Contact Details Failure": props<{ error: string }>(),

    "Add Contact Save": props<{ data: OrganizationContact }>(),
    "Contact Saved Success": props<{ data: OrganizationContact }>(),
    "Contact Saved Failure": props<{ error: string }>(),

    "Edit Contact": props<{ data: OrganizationContact }>(),
    "Edit Contact Success": props<{ data: OrganizationContact }>(),
    "Edit Contact Failure": props<{ error: string }>(),

    "Delete Contact": props<{ id: any }>(),
    "Delete Contact Success": props<{ id: any }>(),
    "Delete Contact Failure": props<{ error: string }>(),
  },
});
